import * as React from "react";
import { forwardRef } from "react";
const SvgPlusIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-plus", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("line", { x1: 12, y1: 5, x2: 12, y2: 19 }), /* @__PURE__ */ React.createElement("line", { x1: 5, y1: 12, x2: 19, y2: 12 }));
const ForwardRef = forwardRef(SvgPlusIcon);
export { ForwardRef as ReactComponent };
